import UserWithAvatar from "components/Atoms/UserWithAvatar";
import React from "react";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import { MultiModalPickerProps } from "../props";
import MultiUserToClientList from "./MultiUserToClientList";

interface Props extends MultiModalPickerProps<server.dto.UserToClientSmall> {
  canChooseDeactivated?: boolean
  environment: server.dto.Environments | "both"

  customLabel?: string
}

const MultiUserToClientModalPicker = (props: Props) => {
  const { canChooseDeactivated, environment, customLabel, ...rest } = props;

  return <MultiModalPickerWithChooseButton<server.dto.UserToClientSmall>
    onNewClicked={() => { }}
    renderLabelContent={u => <UserWithAvatar user={u.user} />}
    getId={u => u.userToClientId}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={props.customLabel ?? RESX.SoUser.Users}
    modalSize="small"
    renderModalContent={(editedValue, setEditedValue) => <MultiUserToClientList
      excludeKeys={editedValue.map(u => u.userToClientId)}
      onChange={setEditedValue}
      value={editedValue}
      canChooseDeactivated={canChooseDeactivated}
      environment={environment}
    />}
    {...rest}
  />
};

export default MultiUserToClientModalPicker;